import axiosInstance from '../axios/axiosInstance'

export async function getUserDataAPI () {
  const response = await axiosInstance.get(
    '/auth/userdata'
  )
  return response
}
